// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Urbanist", sans-serif !important;
}

/* 
scss
 */
/* 
Body Theme Color
 */
/* 
Dark Theme Colors
*/
/* 
Button Theme
*/
/* 
Max Dashboard scss
*/
/* 
Min Dashboard scss
*/
/* 
Max Dashboard scss
*/
.TableViewPopup_dashboard__Bk8Cv {
  width: calc(100% - 320px);
  position: relative;
  left: 290px;
  padding: 30px 30px 80px 30px;
  border-radius: 8px;
  min-height: auto !important;
  background-color: #F5F6FA;
  overflow-y: auto;
}

.TableViewPopup_dashboardContain__tpS2Y {
  width: calc(100% - 320px);
  background-Color: #F5F6FA;
  border-radius: 8px;
}

.TableViewPopup_bodythemedark__eT38U .TableViewPopup_dashboardContain__tpS2Y,
.TableViewPopup_bodythemedark__eT38U .TableViewPopup_dashboard__Bk8Cv,
.TableViewPopup_bodythemedark__eT38U .TableViewPopup_cont2__WSly8 {
  background-Color: #0f1824;
}

.TableViewPopup_top_header__PG0wA .TableViewPopup_top_header_inner__z02ox {
  background-color: transparent;
  height: auto;
  overflow-y: unset;
}

/* 
Min Dashboard scss
*/
.TableViewPopup_cont2__WSly8 {
  width: calc(100% - 50px);
  left: 50px;
  position: relative;
  padding: 30px;
  border-radius: 8px;
  background: #F5F6FA;
  /* 
  background-Color: \$dashboardbackgroundColor;
    padding-bottom: 8%;
  */
}

.TableViewPopup_subLink__pQ1zR svg {
  position: relative;
  top: -2px;
  left: -7px;
}

.TableViewPopup_footer__6yLKS {
  height: 70px;
}

body {
  background-color: #fff;
}

/* 
THEME CHANGE
*/
.TableViewPopup_bodythemelight__fp7qv {
  background-color: #fff;
  padding-top: 90px;
}

.TableViewPopup_bodythemedark__eT38U {
  background-color: #132337;
  padding-top: 90px;
}

/* 
Header Navbar Theme
*/
.TableViewPopup_headerthemelight__Jza1g {
  background-color: #fff;
}

.TableViewPopup_headerthemedark__LXffa {
  background-color: #132337;
}

.TableViewPopup_top_header__PG0wA {
  min-height: 90px;
  display: flex;
  align-items: center;
  position: fixed;
  width: 100%;
  z-index: 1;
}

/* 
LEFT MENU THEME CHANGE
*/
.TableViewPopup_menuthemelight__LhB3c {
  background-color: #fff;
}

.TableViewPopup_menuthemedark__kDS-2 {
  background-color: #132337;
}

/* 
LEFT MENU LINKS THEME CHANGE
*/
.TableViewPopup_menulinklight__X6MCA span {
  color: #666666 !important;
}

.TableViewPopup_menulinklight__X6MCA a {
  color: #CBCBCB !important;
}

.TableViewPopup_menulinklight__X6MCA:hover span, .TableViewPopup_menulinklight__X6MCA:hover a {
  color: #fff !important;
}

.TableViewPopup_menulinkdarkSelected__O\\+6\\+L {
  background-color: #1c2e45;
  color: #fff;
}

.TableViewPopup_menuthemelight__LhB3c .TableViewPopup_menulinklightSelected__QmHyj {
  /*background-color: \$lightthemecolor;*/
  color: #fff !important;
  background-color: #205440;
}

.TableViewPopup_menulinkdark__0CoHZ {
  color: #60677e !important;
}

.TableViewPopup_menulinklight__X6MCA:hover {
  color: #fff !important;
  background-color: #205440;
}

.TableViewPopup_menulinkdark__0CoHZ:hover {
  background-color: #1c2e45;
  color: #fff;
}

/* 
BODY HEADERS
*/
.TableViewPopup_headinglight__X-ybd {
  color: #60677e;
}

.TableViewPopup_headingdark__K-CKc {
  color: #60677e;
}

/* 
SEARCH BOX THEME COLOR
*/
.TableViewPopup_searchboxlight__IW4y0 {
  background-color: #fff;
  border: none;
}

.TableViewPopup_searchboxdark__yI0sj {
  background-color: #132337;
  color: #fff;
  border: none;
}

.TableViewPopup_searchboxdark__yI0sj::placeholder {
  color: #60677e;
}

/* 
CUSTOM TABLE THEME COLOR
*/
.TableViewPopup_tableheadlight__fLoF6 {
  background-color: #205440;
  border-radius: 5px 5px 0px 0px;
}

.TableViewPopup_tableheadlight__fLoF6 th {
  color: #fff;
}

thead .TableViewPopup_tableheadlight__fLoF6 th:first-child,
thead .TableViewPopup_tableheaddark__ByeKf th:first-child {
  border-radius: 5px 0 0 0px;
}

thead .TableViewPopup_tableheadlight__fLoF6 th:last-child,
thead .TableViewPopup_tableheaddark__ByeKf th:last-child {
  border-radius: 0 5px 0px 0;
}

th:first-child {
  border-radius: 0px;
}

td:last-child {
  border-radius: 0px;
}

table.TableViewPopup_table__p20dt.TableViewPopup_table-borderless__6wz24 {
  border-collapse: separate !important;
  border-spacing: 0 0px !important;
}

.TableViewPopup_tableheaddark__ByeKf {
  background-color: #1e1e2d;
  color: #fff;
}

.TableViewPopup_table-borderless__6wz24 tr:nth-child(even) {
  background-color: #F9FAFB;
}

.TableViewPopup_table-borderless__6wz24 .TableViewPopup_left-section__YKZOb {
  padding-top: 10px;
}

.TableViewPopup_tablebodylight__eYYYF td,
.TableViewPopup_tablebodydark__jZy-n td {
  padding: 1rem 1rem !important;
}

.TableViewPopup_tablebodylight__eYYYF {
  background-color: #fff;
}
.TableViewPopup_tablebodylight__eYYYF:hover {
  background-color: #ddecf9;
  cursor: pointer;
}

.TableViewPopup_tablebodydark__jZy-n {
  /* background-color: \$primarydark-color; */
  color: #60677e;
}
.TableViewPopup_tablebodydark__jZy-n:hover {
  background-color: rgba(33, 150, 243, 0.1);
  cursor: pointer;
}

/* 
PAGINATION THEME COLOR
*/
.TableViewPopup_paginationlight__x\\+QwH {
  color: #60677e !important;
  font-size: 13px !important;
}

.TableViewPopup_paginationdark__jrN5e {
  color: #60677e !important;
  font-size: 13px !important;
}

/* 
SETTING FORM THEME COLOR
*/
.TableViewPopup_formthemelight__9E6G5 {
  background-color: #fff;
  color: #1d1d1d !important;
  box-shadow: 0px 10px 35px 0px rgba(56, 71, 109, 0.08);
}

.TableViewPopup_formthemedark__SEbrt {
  background-color: #1e1e2d;
  color: #60677e !important;
  font-size: 14px;
}
.TableViewPopup_formthemedark__SEbrt ::placeholder {
  color: #60677e;
}

/* 
VIEW FORM DETAILS BOX THEME COLOR
*/
.TableViewPopup_viewformlight__pK93I {
  background-color: #f3f6f9;
}

.TableViewPopup_permissionboxlight__omoDD {
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
}

.TableViewPopup_permissionboxdark__dI-1S {
  background-color: #151521;
  border: solid 1px #242434;
}

.TableViewPopup_errormsgclr__40cyw {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}

/* 
Graph theme
*/
.TableViewPopup_graphclrlight__SG\\+F5 {
  background-color: #fff;
}

.TableViewPopup_graphclrdark__TCTv8 {
  background-color: #1e1e2d;
}

/* 
Counter theme
*/
#TableViewPopup_card1bglight__xbpCL {
  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */
  background-color: #fff;
}

#TableViewPopup_card1bglight__xbpCL:hover {
  background: #f7fffc;
}

#TableViewPopup_card1bgdark__Q9o0M {
  background: #392f28;
}

#TableViewPopup_card1bgdark__Q9o0M:hover {
  background: #f7fffc;
}

#TableViewPopup_card2bglight__qvHLE {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #fff;
}

#TableViewPopup_card2bglight__qvHLE:hover {
  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */
  background-color: #f7fffc;
}

#TableViewPopup_card2bgdark__fuIJ1 {
  background: #1c3238;
}

#TableViewPopup_card3bglight__ybE2T {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #fff;
}

#TableViewPopup_card3bglight__ybE2T:hover {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #f7fffc;
}

#TableViewPopup_card3bgdark__UNBgK {
  background: #3a2434;
}

#TableViewPopup_card4bglight__TKUGy {
  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */
  background-color: #fff;
}

#TableViewPopup_card4bglight__TKUGy:hover {
  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */
  background-color: #f7fffc;
}

#TableViewPopup_card4bgdark__1QTv4 {
  background: #2f264f;
}

#TableViewPopup_card1bgdark__Q9o0M a, #TableViewPopup_card1bgdark__Q9o0M p,
#TableViewPopup_card2bgdark__fuIJ1 a, #TableViewPopup_card2bgdark__fuIJ1 p,
#TableViewPopup_card3bgdark__UNBgK a, #TableViewPopup_card3bgdark__UNBgK p,
#TableViewPopup_card4bgdark__1QTv4 a, #TableViewPopup_card4bgdark__1QTv4 p {
  color: #fff;
}

/* 
Action button theme
*/
.TableViewPopup_actionbtnlight__gwhXA {
  color: rgba(70, 71, 91, 0.8705882353);
}

.TableViewPopup_actionbtndark__a9GeW {
  color: #60677e;
}

/* 
profile dropdowntheme
*/
.TableViewPopup_profiledropdownlight__Ky5fH {
  background-color: #fff;
}

.TableViewPopup_profiledropdowndark__0TwsG {
  background-color: #151521;
}

.TableViewPopup_settingsection__1qZmP #TableViewPopup_addform__-eoSQ.TableViewPopup_formthemedark__SEbrt .TableViewPopup_savebtn__V2WZc {
  background-color: #0a2574;
  color: #fff;
}

#TableViewPopup_addform__-eoSQ.TableViewPopup_formthemedark__SEbrt .TableViewPopup_savebtn__V2WZc {
  background-color: #0a2574;
  color: #fff;
}

.TableViewPopup_profile_conatiner__0Hgao {
  border-radius: 5px !important;
}

.TableViewPopup_bodythemedark__eT38U .TableViewPopup_ag-theme-alpine__pH-D3 .TableViewPopup_ag-row__2cNcJ {
  background: #000 !important;
}

.TableViewPopup_bodythemedark__eT38U .TableViewPopup_formbtn__CH0BD {
  background-color: #0a2574;
}

.TableViewPopup_bodythemedark__eT38U .TableViewPopup_resetbtn__N\\+kZd {
  color: #fff;
  background-color: transparent;
  border: solid 1px #0a2574;
}

.TableViewPopup_bodythemedark__eT38U .TableViewPopup_resetbtn__N\\+kZd:hover {
  background-color: #0a2574;
}

.TableViewPopup_headingdark__K-CKc span {
  background-color: #132337;
}

.TableViewPopup_resetbtn__N\\+kZd {
  font-size: 16px;
  font-weight: 600;
  border-radius: 5px;
  background-color: transparent;
  border: solid 1px #205440;
  color: #205440;
  min-width: 113px;
}

.TableViewPopup_resetbtn__N\\+kZd:hover,
.TableViewPopup_resetbtn__N\\+kZd:active,
.TableViewPopup_resetbtn__N\\+kZd:focus {
  background-color: #205440;
  color: #fff;
}

.TableViewPopup_addBtn__IqAbp {
  min-width: 140px;
  height: 44px;
  color: #fff;
  background-color: #38A169;
  border: none;
  font-size: 16px;
  font-weight: 600;
}

.TableViewPopup_addBtn__IqAbp svg {
  margin-right: 10px;
  position: relative;
  top: 2px;
}

.TableViewPopup_addBtn__IqAbp:hover {
  color: #fff;
  background-color: #38A169;
  border: none;
}

.TableViewPopup_cust_addBtn__sKmpU.TableViewPopup_addBtn__IqAbp svg {
  top: 2px;
}

.TableViewPopup_deleteBtn__\\+PFBA {
  min-width: auto;
  padding: 10px 0;
  background-color: #F94747;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  border: none;
}

.TableViewPopup_deleteBtn__\\+PFBA {
  min-width: auto !important;
  height: 50px !important;
  background-color: #205440 !important;
  color: #fff !important;
  font-size: 16px !important;
  font-weight: 600 !important;
  border: none !important;
  padding: 0.375rem 1rem !important;
}

.TableViewPopup_deleteBtn__\\+PFBA:active, .TableViewPopup_deleteBtn__\\+PFBA:focus {
  background-color: #F94747 !important;
  color: #fff !important;
  box-shadow: none !important;
}

.TableViewPopup_deleteBtn__\\+PFBA svg {
  position: relative;
  top: -2px;
}

.TableViewPopup_deleteBtn__\\+PFBA:hover,
.TableViewPopup_deleteBtn__\\+PFBA:active,
.TableViewPopup_deleteBtn__\\+PFBA:focus {
  background-color: #205440 !important;
  color: #fff;
  border: none;
}

.TableViewPopup_confirmBtn__TeC2Y {
  background-color: #205440;
}

.TableViewPopup_confirmBtn__TeC2Y:hover,
.TableViewPopup_confirmBtn__TeC2Y:active,
.TableViewPopup_confirmBtn__TeC2Y:focus {
  background-color: #205440;
}

.TableViewPopup_confirmBtn__TeC2Y svg {
  top: 0;
}

.TableViewPopup_back_dlt__p5TeG {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.TableViewPopup_delPopContainer__JGVWI .TableViewPopup_modal-body__cHyaE {
  padding: 25px;
  text-align: center;
}

.TableViewPopup_delPopContainer__JGVWI .TableViewPopup_delet_icon__922fy {
  margin-bottom: 11px;
}

.TableViewPopup_delPopContainer__JGVWI p {
  color: #131f43;
  font-size: 14px;
  font-weight: 700;
}

.TableViewPopup_arrowback__zhNwv svg {
  fill: #000;
}

.TableViewPopup_bodythemedark__eT38U .TableViewPopup_arrowback__zhNwv {
  background-color: #0a2574;
  color: #fff;
}

.TableViewPopup_bodythemedark__eT38U .TableViewPopup_arrowback__zhNwv svg {
  fill: #fff;
}

.TableViewPopup_bodythemedark__eT38U .TableViewPopup_drpdwn_btn__tA3kq {
  background-color: #132337;
}

.TableViewPopup_bodythemedark__eT38U .TableViewPopup_empname__cUDDH {
  color: #60677e !important;
}

.TableViewPopup_bodythemedark__eT38U .TableViewPopup_navitemli__GyHqs a {
  background-color: transparent;
  border: solid 1px #0a2574;
  color: #fff;
}

.TableViewPopup_bodythemedark__eT38U .TableViewPopup_tabnavli__-xb-e a.TableViewPopup_settingsgeneral__hwXei,
.TableViewPopup_bodythemedark__eT38U .TableViewPopup_tabnavli__-xb-e a.TableViewPopup_settingslinks__TqsRQ:hover {
  background-color: #0a2574;
  color: #fff;
}

.TableViewPopup_bodythemedark__eT38U .TableViewPopup_tabnavli__-xb-e a.TableViewPopup_settingslinks__TqsRQ {
  background-color: transparent;
  border: solid 1px #0a2574;
  color: #fff;
}

@media only screen and (max-width: 1200px) {
  .TableViewPopup_tableheadlight__fLoF6 th {
    min-width: 100px;
  }
}
@media only screen and (max-width: 1024px) {
  .TableViewPopup_dashboard__Bk8Cv {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 998px) {
  #TableViewPopup_dashboardcont2__hWMNB {
    height: auto !important;
  }
}
@media only screen and (max-width: 767px) {
  .TableViewPopup_sectionright__mOBUK {
    float: unset !important;
  }
  .TableViewPopup_dashboard__Bk8Cv {
    padding: 10px 10px !important;
  }
}
@media only screen and (max-width: 600px) {
  .TableViewPopup_cont2__WSly8 {
    width: calc(100% - 50px) !important;
    left: 50px !important;
    position: relative !important;
    padding: 20px 10px !important;
  }
  .TableViewPopup_bodythemelight__fp7qv, .TableViewPopup_bodythemedark__eT38U {
    padding-top: 165px;
  }
}
@media (min-width: 576px) {
  .TableViewPopup_exer_modal_contain__nwIVN .TableViewPopup_modal-dialog__Lc0ex {
    max-width: 1055px;
  }
  .TableViewPopup_delPopContainer__JGVWI .TableViewPopup_modal-dialog__Lc0ex {
    max-width: 350px;
  }
}
/* Popup style */
.TableViewPopup_popupbox__a0ady {
  position: fixed;
  background: rgba(0, 0, 0, 0.46);
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 99;
}

#TableViewPopup_box__2aK4E {
  position: relative;
  width: 55%;
  margin: 0 auto;
  height: auto;
  max-height: 70vh;
  margin-top: calc(30vh - 20px);
  border-radius: 4px;
  padding: 20px;
  overflow: auto;
}

.TableViewPopup_closeicon__xX-PQ {
  content: "x";
  cursor: pointer;
  position: fixed;
  right: calc(22% - 18px);
  top: calc(27vh - 25px);
  background: #ededed;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  line-height: 20px;
  text-align: center;
  border: 1px solid #999;
  font-size: 20px;
}

#TableViewPopup_addheading__L0Wjm {
  font-size: 20px;
}

.TableViewPopup_nametitle__1BORB {
  font-size: 16px;
}

.TableViewPopup_name__d-fY- {
  font-size: 16px;
  color: #fff;
}

.TableViewPopup_detailsdiv__v6KtY {
  padding: 5px;
  background-color: #fff;
}

.TableViewPopup_profilepicdiv__JsY9Q {
  border-radius: 5px;
}

.TableViewPopup_profile_imgsection__Tz7nf {
  display: flex;
  justify-content: center;
  align-items: center;
}

.TableViewPopup_profilepic__igUKH {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 1px solid rgba(33, 37, 41, 0.4588235294);
  padding: 5px;
}

.TableViewPopup_namesection__jDhA7 {
  text-align: center;
}

#TableViewPopup_profilename__xS1eF {
  font-size: 14px;
  margin-top: 30px;
  text-align: center;
}

.TableViewPopup_profileemail__sIv64 {
  font-size: 12px;
}

#TableViewPopup_profiledob__CoUKF {
  font-size: 12px;
}

#TableViewPopup_empdiv__2\\+KYM {
  padding: 5px 0px 0px 15px;
  margin-bottom: 10px;
  border-radius: 5px;
}
#TableViewPopup_empdiv__2\\+KYM .TableViewPopup_title__QI5k1 {
  font-size: 13px;
}
#TableViewPopup_empdiv__2\\+KYM .TableViewPopup_empname__cUDDH {
  font-size: 14px;
  padding-bottom: 8px;
  word-break: break-word;
}

@media only screen and (max-width: 400px) {
  #TableViewPopup_box__2aK4E {
    width: 80%;
    margin: 90px 40px;
  }
  .TableViewPopup_closeicon__xX-PQ {
    right: calc(32% - 64px);
    top: calc(23vh - 25px);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/Variables/Variables.scss","webpack://./src/components/TableViewPopup/TableViewPopup.module.scss"],"names":[],"mappings":"AAEA;EACE,8CAAA;ACAF;;ADGA;;EAAA;AAqCA;;EAAA;AAWA;;CAAA;AAKA;;CAAA;AASA;;CAAA;AAQA;;CAAA;AAMA;;CAAA;AAIA;EACE,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,4BAAA;EACA,kBAAA;EACA,2BAAA;EACA,yBAAA;EACA,gBAAA;AC3DF;;AD6DA;EACE,yBAAA;EACA,yBAlFO;EAmFP,kBAAA;AC1DF;;AD4DA;;;EAGE,yBAjEoB;ACQtB;;AD2DA;EACE,6BAAA;EACA,YAAA;EACA,iBAAA;ACxDF;;AD2DA;;CAAA;AAIA;EACE,wBAtCU;EAuCV,UAtCS;EAuCT,kBAAA;EACA,aA9CiB;EA+CjB,kBAAA;EACA,mBA1GO;EA2GP;;;GAAA;ACtDF;;AD4DA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;ACzDF;;AD8DA;EACE,YAAA;AC3DF;;AD8DA;EACE,sBA7FY;ACkCd;;AD8DA;;CAAA;AAGA;EACE,sBApGY;EAqGZ,iBAAA;AC3DF;;AD6DA;EACE,yBAnHgB;EAoHhB,iBAAA;AC1DF;;AD6DA;;CAAA;AAGA;EACE,sBAhHY;ACsDd;;AD6DA;EACE,yBA/HgB;ACqElB;;AD4DA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;ACzDF;;AD4DA;;CAAA;AAGA;EACE,sBAnIY;AC0Ed;;AD2DA;EACE,yBAjJgB;ACyFlB;;AD2DA;;CAAA;AAGA;EACE,yBAAA;ACxDF;;AD2DA;EACE,yBAAA;ACxDF;;AD2DA;EACE,sBAAA;ACxDF;;AD2DA;EACE,yBAlKsB;EAmKtB,WA1JY;ACkGd;;AD0DA;EACE,sCAAA;EACA,sBAAA;EACA,yBA/Lc;ACwIhB;;AD0DA;EACE,yBAAA;ACvDF;;AD0DA;EACE,sBAAA;EACA,yBAxMc;ACiJhB;;AD0DA;EACE,yBArLsB;EAsLtB,WA7KY;ACsHd;;AD0DA;;CAAA;AAGA;EACE,cAjLe;AC0HjB;;AD0DA;EACE,cArLe;AC8HjB;;AD0DA;;CAAA;AAGA;EACE,sBA/LY;EAgMZ,YAAA;ACvDF;;AD0DA;EACE,yBA/MgB;EAgNhB,WArMY;EAsMZ,YAAA;ACvDF;;ADyDA;EACE,cAtMe;ACgJjB;;ADyDA;;CAAA;AAGA;EACE,yBAhPc;EAiPd,8BAAA;ACtDF;;ADwDA;EACE,WApNY;AC+Jd;;ADuDA;;EAEE,0BAAA;ACpDF;;ADsDA;;EAEE,0BAAA;ACnDF;;ADqDA;EACE,kBAAA;AClDF;;ADoDA;EACE,kBAAA;ACjDF;;ADmDA;EACE,oCAAA;EACA,gCAAA;AChDF;;ADmDA;EACE,yBAlOkB;EAmOlB,WA3OY;AC2Ld;;ADkDA;EACE,yBAAA;AC/CF;;ADiDA;EACE,iBAAA;AC9CF;;ADgDA;;EAEE,6BAAA;AC7CF;;AD+CA;EACE,sBAxPY;AC4Md;AD8CE;EACE,yBAAA;EACA,eAAA;AC5CJ;;AD+CA;EACC,0CAAA;EACC,cA9Pe;ACkNjB;AD8CE;EACE,yCAAA;EACA,eAAA;AC5CJ;;ADgDA;;CAAA;AAGA;EACE,yBAAA;EACA,0BAAA;AC7CF;;AD+CA;EACE,yBAAA;EACA,0BAAA;AC5CF;;AD+CA;;CAAA;AAGA;EACE,sBAzRY;EA0RZ,yBAAA;EACA,qDAAA;AC5CF;;AD8CA;EACE,yBAtRkB;EAuRlB,yBAAA;EACA,eAAA;AC3CF;AD6CE;EACE,cAhSa;ACqPjB;;ADgDA;;CAAA;AAGA;EACE,yBA/SgB;ACkQlB;;ADgDA;EACE,yBAAA;EACA,yBAAA;AC7CF;;AD+CA;EACE,yBAAA;EACA,yBAAA;AC5CF;;AD+CA;EACE,UAAA;EACA,eAAA;EACA,eAAA;AC5CF;;AD+CA;;CAAA;AAGA;EACE,sBAlUY;ACsRd;;AD+CA;EACE,yBA9TkB;ACkRpB;;ADgDA;;CAAA;AAGA;EACE,iGAAA;EACA,sBA/UY;ACkSd;;AD+CA;EACE,mBAAA;AC5CF;;AD8CA;EACE,mBAAA;AC3CF;;AD6CA;EACE,mBAAA;AC1CF;;AD4CA;EACE,gGAAA;EACA,sBA5VY;ACmTd;;AD2CA;EACE,gGAAA;EACA,yBAAA;ACxCF;;AD0CA;EACE,mBAAA;ACvCF;;AD0CA;EACE,gGAAA;EACA,sBAxWY;ACiUd;;ADyCA;EACE,gGAAA;EACA,yBAAA;ACtCF;;ADyCA;EACE,mBAAA;ACtCF;;ADyCA;EACE,gGAAA;EACA,sBArXY;AC+Ud;;ADwCA;EACE,gGAAA;EACA,yBAAA;ACrCF;;ADuCA;EACE,mBAAA;ACpCF;;ADuCA;;;;EAIE,WAnYY;AC+Vd;;ADuCA;;CAAA;AAGA;EACE,qCAAA;ACpCF;;ADuCA;EACE,cA3Ye;ACuWjB;;ADwCA;;CAAA;AAGA;EACE,sBAAA;ACrCF;;ADwCA;EACE,yBAAA;ACrCF;;ADwCA;EACE,yBAtaqB;EAuarB,WA/ZY;AC0Xd;;ADuCA;EACE,yBA1aqB;EA2arB,WAnaY;AC+Xd;;ADuCA;EACE,6BAAA;ACpCF;;ADuCA;EACE,2BAAA;ACpCF;;ADuCA;EACE,yBAvbqB;ACmZvB;;ADuCA;EACE,WAnbY;EAobZ,6BAAA;EACA,yBAAA;ACpCF;;ADuCA;EACE,yBAjcqB;AC6ZvB;;ADwCA;EACE,yBAzcgB;ACoalB;;ADwCA;EACE,eAAA;EACA,gBAzec;EA0ed,kBAAA;EACA,6BAAA;EACA,yBAAA;EACA,cAvec;EAwed,gBAAA;ACrCF;;ADuCA;;;EAGE,yBA7ec;EA8ed,WA9cY;AC0ad;;ADuCA;EACE,gBAAA;EACA,YAAA;EACA,WApdY;EAqdZ,yBA3eY;EA4eZ,YAAA;EACA,eAAA;EACA,gBA9fc;AC0dhB;;ADuCA;EACE,kBAAA;EACA,kBAAA;EACA,QAAA;ACpCF;;ADuCA;EACE,WAleY;EAmeZ,yBAzfY;EA0fZ,YAAA;ACpCF;;ADuCA;EACE,QAAA;ACpCF;;ADuCA;EACE,eAAA;EACF,eAAA;EACE,yBA7fW;EA8fX,WA/eY;EAgfZ,eAAA;EACA,gBAvhBc;EAwhBd,YAAA;ACpCF;;ADuCA;EACE,0BAAA;EACA,uBAAA;EACA,oCAAA;EACA,sBAAA;EACA,0BAAA;EACA,2BAAA;EACA,uBAAA;EACA,iCAAA;ACpCF;;ADuCA;EACE,oCAAA;EACA,sBAAA;EACA,2BAAA;ACpCF;;ADuCA;EACE,kBAAA;EACA,SAAA;ACpCF;;ADuCA;;;EAGE,oCAAA;EACA,WA/gBY;EAghBZ,YAAA;ACpCF;;ADuCA;EACE,yBApjBc;ACghBhB;;ADuCA;;;EAGE,yBA1jBc;ACshBhB;;ADuCA;EACE,MAAA;ACpCF;;ADwCA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;ACrCF;;ADwCA;EACE,aAAA;EACA,kBAAA;ACrCF;;ADwCA;EACE,mBAAA;ACrCF;;ADwCA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;ACrCF;;ADwCA;EACE,UAAA;ACrCF;;ADwCA;EACE,yBApkBqB;EAqkBrB,WA7jBY;ACwhBd;;ADwCA;EACE,UAjkBY;AC4hBd;;ADwCA;EACE,yBAhlBgB;AC2iBlB;;ADwCA;EACE,yBAAA;ACrCF;;ADwCA;EACE,6BAAA;EACA,yBAAA;EACA,WA/kBY;AC0iBd;;ADwCA;;EAEE,yBA5lBqB;EA6lBrB,WArlBY;ACgjBd;;ADuCA;EACE,6BAAA;EACA,yBAAA;EACA,WA1lBY;ACsjBd;;ADwCA;EACE;IACE,gBAAA;ECrCF;AACF;ADuCA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;ECrCF;AACF;ADuCA;EACE;IACE,uBAAA;ECrCF;AACF;ADuCA;EACE;IACE,uBAAA;ECrCF;EDuCA;IACE,6BAAA;ECrCF;AACF;ADuCA;EACE;IACE,mCAAA;IACA,qBAAA;IACA,6BAAA;IACA,6BAAA;ECrCF;EDuCA;IACE,kBAAA;ECrCF;AACF;ADwCA;EACE;IACI,iBAAA;ECtCJ;EDwCA;IACI,gBAAA;ECtCJ;AACF;AAlpBA,gBAAA;AACA;EACI,eAAA;EACA,+BAAA;EACA,WAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;AAopBJ;;AAjpBE;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,6BAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;AAopBJ;;AAjpBE;EACE,YAAA;EACA,eAAA;EACA,eAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAopBJ;;AAhpBE;EACE,eAAA;AAmpBJ;;AAhpBA;EACI,eAAA;AAmpBJ;;AAhpBA;EACI,eAAA;EACA,WDHU;ACspBd;;AAhpBA;EACI,YAAA;EACA,sBDRU;AC2pBd;;AAhpBA;EAEI,kBAAA;AAkpBJ;;AA/oBA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAkpBJ;;AA/oBA;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,gDAAA;EACA,YAAA;AAkpBJ;;AA/oBA;EACI,kBAAA;AAkpBJ;;AA/oBA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;AAkpBJ;;AAhpBA;EACI,eAAA;AAmpBJ;;AAhpBA;EACI,eAAA;AAmpBJ;;AA/oBA;EACI,yBAAA;EACA,mBAAA;EACA,kBAAA;AAkpBJ;AAhpBI;EAEI,eAAA;AAipBR;AA9oBI;EACI,eAAA;EACA,mBAAA;EACA,sBAAA;AAgpBR;;AA1oBA;EACI;IACI,UAAA;IACA,iBAAA;EA6oBN;EA1oBI;IACE,uBAAA;IACA,sBAAA;EA4oBN;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100..900;1,100..900&display=swap');\n\nbody {\n  font-family: \"Urbanist\", sans-serif !important;\n}\n\n/* \nscss\n */\n$font-regular: 400;\n$font-medium: 500;\n$font-semiBold: 600;\n$font-bold: 700;\n$font-extraBold: 800;\n$font-black: 900;\n\n$mainBg: #F5F6FA;\n$primary-color: #205440;\n$icon-bgcolor: #F6F6F6;\n$text-graycolor: #727272;\n$cardIcon1-bg: #F3F4F8;\n$cardIcon2-bg: #FAF4FB;\n$cardIcon3-bg: #FAF7F3;\n$cardIcon4-bg: #F5F9FC;\n$cardIcon2-color: #AC44BB;\n$cardIcon3-color: #D69A5F;\n$cardIcon4-color: #176CA5;\n$green-color: #38A169;\n$darkGreen-color: #207a4a;\n$placeholder-color: #666666;\n$profile-dark-text: #181818;\n$heading : #0B0D0F;\n$light-gray : #999999;\n$menu_icon : #CBCBCB;\n$red-color : #F94747;\n\n\n\n$darkTheme_blue : #132337;\n$darkTheme_darkBlue : #0f1824;\n$darkTheme_selectBlue : #1c2e45;\n$darkTheme_updateBtn : #0a2574;\n\n/* \nBody Theme Color\n */\n$lightthemecolor: #f3f6f9;\n$darkthemecolor: #151521;\n\n$white-color: #fff;\n$black-color: #1d1d1d;\n$fullBlack-color: #1d1d1d;\n$lightthemetext: #60677e;\n\n/* \nDark Theme Colors\n*/\n$primarydark-color: #1e1e2d;\n\n/* \nButton Theme\n*/\n$primary-btncolor: #205440;\n$secondary-btncolor: rgba(37, 105, 109, 0.864);\n\n$tableheadlightbg: #e9eaf0;\n\n\n/* \nMax Dashboard scss\n*/\n$dashboardwidth: calc(100% - 320px);\n$dashboardposition: absolute;\n$dashboardleft: 290px;\n$dashboardpadding: 30px;\n\n/* \nMin Dashboard scss\n*/\n$dashwidth: calc(100% - 50px);\n$dashleft: 50px;\n\n/* \nMax Dashboard scss\n*/\n\n.dashboard {\n  width: calc(100% - 320px);\n  position: relative;\n  left: 290px;\n  padding: 30px 30px 80px 30px;\n  border-radius: 8px;\n  min-height: auto !important;\n  background-color: #F5F6FA;\n  overflow-y: auto;\n}\n.dashboardContain { \n  width: calc(100% - 320px);\n  background-Color:$mainBg;\n  border-radius: 8px;\n}\n.bodythemedark .dashboardContain,\n.bodythemedark .dashboard, \n.bodythemedark .cont2 { \n  background-Color: $darkTheme_darkBlue;\n}\n.top_header .top_header_inner {\n  background-color: transparent;\n  height: auto;\n  overflow-y: unset;\n}\n\n/* \nMin Dashboard scss\n*/\n\n.cont2 {\n  width: $dashwidth;\n  left: $dashleft;\n  position: relative;\n  padding: $dashboardpadding;\n  border-radius: 8px;\n  background: $mainBg;\n  /* \nbackground-Color: $dashboardbackgroundColor;\n  padding-bottom: 8%;\n*/\n}\n\n.subLink svg {\n  position: relative;\n  top: -2px;\n  left: -7px;\n}\n\n\n\n.footer {\n  height: 70px;\n}\n\nbody {\n  background-color: $white-color;\n}\n\n/* \nTHEME CHANGE\n*/\n.bodythemelight {\n  background-color: $white-color;\n  padding-top: 90px;\n}\n.bodythemedark {\n  background-color: $darkTheme_blue;\n  padding-top: 90px;\n}\n\n/* \nHeader Navbar Theme\n*/\n.headerthemelight {\n  background-color: $white-color;\n}\n\n.headerthemedark {\n  background-color: $darkTheme_blue;\n}\n.top_header {\n  min-height: 90px;\n  display: flex;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  z-index: 1; \n}\n\n/* \nLEFT MENU THEME CHANGE\n*/\n.menuthemelight {\n  background-color: $white-color;\n}\n.menuthemedark {\n  background-color: $darkTheme_blue;\n}\n\n/* \nLEFT MENU LINKS THEME CHANGE\n*/\n.menulinklight span {\n  color: $placeholder-color !important;\n}\n\n.menulinklight a {\n  color: $menu_icon !important;\n}\n\n.menulinklight:hover span, .menulinklight:hover a { \n  color: $white-color !important;\n}\n\n.menulinkdarkSelected {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n.menuthemelight .menulinklightSelected {\n  /*background-color: $lightthemecolor;*/\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark {\n  color: $lightthemetext !important;\n}\n\n.menulinklight:hover {\n  color: $white-color !important;\n  background-color: $primary-color;\n}\n\n.menulinkdark:hover {\n  background-color: $darkTheme_selectBlue;\n  color: $white-color;\n}\n\n/* \nBODY HEADERS\n*/\n.headinglight {\n  color: $lightthemetext;\n}\n\n.headingdark {\n  color: $lightthemetext;\n}\n\n/* \nSEARCH BOX THEME COLOR\n*/\n.searchboxlight {\n  background-color: $white-color;\n  border: none;\n}\n\n.searchboxdark {\n  background-color: $darkTheme_blue;\n  color: $white-color;\n  border: none;\n}\n.searchboxdark::placeholder {\n  color: $lightthemetext;\n}\n\n/* \nCUSTOM TABLE THEME COLOR\n*/\n.tableheadlight {\n  background-color: $primary-color;\n  border-radius: 5px 5px 0px 0px;\n}\n.tableheadlight th {\n  color: $white-color;\n}\nthead .tableheadlight th:first-child,\nthead .tableheaddark th:first-child {\n  border-radius: 5px 0 0 0px;\n} \nthead .tableheadlight th:last-child,\nthead .tableheaddark th:last-child  {\n  border-radius: 0 5px 0px 0;\n}\nth:first-child {\n  border-radius: 0px;\n} \ntd:last-child {\n  border-radius: 0px;\n}\ntable.table.table-borderless{\n  border-collapse: separate !important;\n  border-spacing: 0 0px !important;\n}\n\n.tableheaddark {\n  background-color: $primarydark-color;\n  color: $white-color;\n}\n.table-borderless tr:nth-child(even) {\n  background-color: #F9FAFB;\n}\n.table-borderless .left-section {\n  padding-top: 10px;\n}\n.tablebodylight td, \n.tablebodydark td {\n  padding: 1rem 1rem !important;\n}\n.tablebodylight {\n  background-color: $white-color;\n\n  &:hover {\n    background-color: #ddecf9;\n    cursor: pointer;\n  }\n}\n.tablebodydark {\n /* background-color: $primarydark-color; */\n  color: $lightthemetext;\n\n  &:hover {\n    background-color: rgba(33, 150, 243, 0.1);\n    cursor: pointer;\n  }\n}\n\n/* \nPAGINATION THEME COLOR\n*/\n.paginationlight {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n.paginationdark {\n  color: $lightthemetext !important;\n  font-size: 13px !important;\n}\n\n/* \nSETTING FORM THEME COLOR\n*/\n.formthemelight {\n  background-color: $white-color;\n  color: $black-color !important;\n  box-shadow: 0px 10px 35px 0px rgb(56 71 109 / 8%);\n}\n.formthemedark {\n  background-color: $primarydark-color;\n  color: $lightthemetext !important;\n  font-size: 14px;\n\n  ::placeholder {\n    color: $lightthemetext;\n  }\n}\n\n\n/* \nVIEW FORM DETAILS BOX THEME COLOR\n*/\n.viewformlight {\n  background-color: $lightthemecolor;\n}\n\n.permissionboxlight {\n  background-color: #f8f9fa;\n  border: 1px solid #dee2e6;\n}\n.permissionboxdark {\n  background-color: #151521;\n  border: solid 1px #242434;\n}\n\n.errormsgclr {\n  color: red;\n  font-size: 14px;\n  margin-top: 5px;\n}\n\n/* \nGraph theme\n*/\n.graphclrlight {\n  background-color: $white-color;\n}\n\n.graphclrdark {\n  background-color: $primarydark-color;\n}\n\n\n/* \nCounter theme\n*/\n#card1bglight {\n  /* background: linear-gradient(90deg, rgba(181, 219, 177, 1) 13%, rgba(125, 178, 144, 1) 100%); */\n  background-color: $white-color;\n}\n#card1bglight:hover {\n  background: #f7fffc;\n}\n#card1bgdark {\n  background: #392f28;\n}\n#card1bgdark:hover {\n  background: #f7fffc;\n}\n#card2bglight {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: $white-color;\n}\n#card2bglight:hover {\n  /* background: linear-gradient(90deg, rgba(243, 198, 165, 1) 0%, rgba(248, 163, 168, 1) 100%); */\n  background-color: #f7fffc;\n}\n#card2bgdark {\n  background: #1c3238;\n}\n\n#card3bglight {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: $white-color;\n}\n#card3bglight:hover {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: #f7fffc;\n}\n\n#card3bgdark {\n  background: #3a2434;\n}\n\n#card4bglight {\n  /* background: linear-gradient(90deg, rgba(140, 212, 214, 1) 0%, rgba(150, 202, 247, 1) 100%); */\n  background-color: $white-color;\n}\n#card4bglight:hover {\n  /* background: linear-gradient(90deg, rgba(213, 149, 211, 1) 0%, rgba(174, 132, 192, 1) 100%); */\n  background-color: #f7fffc;\n}\n#card4bgdark {\n  background: #2f264f;\n}\n\n#card1bgdark a, #card1bgdark p,\n#card2bgdark a , #card2bgdark p,\n#card3bgdark a, #card3bgdark p,\n#card4bgdark a, #card4bgdark p {\n  color: $white-color;\n}\n\n/* \nAction button theme\n*/\n.actionbtnlight {\n  color: #46475bde;\n}\n\n.actionbtndark {\n  color: $lightthemetext;\n}\n\n\n/* \nprofile dropdowntheme\n*/\n.profiledropdownlight {\n  background-color: #fff;\n}\n\n.profiledropdowndark {\n  background-color: #151521;\n}\n\n.settingsection #addform.formthemedark .savebtn {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n#addform.formthemedark .savebtn {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n.profile_conatiner {\n  border-radius: 5px !important; \n}\n\n.bodythemedark .ag-theme-alpine .ag-row {\n  background: #000 !important;\n}\n\n.bodythemedark .formbtn {\n  background-color: $darkTheme_updateBtn;\n}\n\n.bodythemedark .resetbtn {\n  color: $white-color;\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n}\n\n.bodythemedark .resetbtn:hover {\n  background-color: $darkTheme_updateBtn;\n}\n\n\n.headingdark span {\n  background-color: $darkTheme_blue;\n}\n\n.resetbtn {\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border-radius: 5px;\n  background-color: transparent;\n  border: solid 1px $primary-color;\n  color:  $primary-color;\n  min-width: 113px;\n}\n.resetbtn:hover, \n.resetbtn:active, \n.resetbtn:focus {\n  background-color: $primary-color;\n  color: $white-color;\n}\n\n.addBtn {\n  min-width: 140px;\n  height: 44px;\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n}\n\n.addBtn svg {\n  margin-right: 10px;\n  position: relative;\n  top: 2px;\n}\n\n.addBtn:hover {\n  color: $white-color;\n  background-color: $green-color;\n  border: none;\n}\n\n.cust_addBtn.addBtn svg {\n  top: 2px;\n}\n\n.deleteBtn {\n  min-width: auto;\npadding: 10px 0;\n  background-color: $red-color;\n  color: $white-color;\n  font-size: 16px;\n  font-weight: $font-semiBold;\n  border: none;\n}\n\n.deleteBtn {\n  min-width: auto !important;\n  height: 50px !important;\n  background-color: $primary-color !important;\n  color: $white-color !important;\n  font-size: 16px !important;\n  font-weight: $font-semiBold !important;\n  border: none !important;\n  padding: .375rem 1rem !important;\n}\n\n.deleteBtn:active, .deleteBtn:focus {\n  background-color: $red-color !important;\n  color: $white-color !important; \n  box-shadow: none !important;\n}\n\n.deleteBtn svg {\n  position: relative;\n  top: -2px;\n}\n\n.deleteBtn:hover, \n.deleteBtn:active, \n.deleteBtn:focus {\n  background-color: $primary-color !important;\n  color: $white-color;\n  border: none;\n}\n\n.confirmBtn {\n  background-color: $primary-color;\n}\n\n.confirmBtn:hover, \n.confirmBtn:active, \n.confirmBtn:focus {\n  background-color: $primary-color;\n}\n\n.confirmBtn svg {\n  top: 0;\n}\n\n\n.back_dlt{\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.delPopContainer .modal-body {\n  padding: 25px;\n  text-align: center;\n}\n\n.delPopContainer .delet_icon {\n  margin-bottom: 11px;\n}\n\n.delPopContainer p {\n  color: #131f43;\n  font-size: 14px;\n  font-weight: 700;\n}\n\n.arrowback svg{\n  fill: #000; \n}\n\n.bodythemedark .arrowback {\n  background-color: $darkTheme_updateBtn; \n  color: $white-color;\n}\n\n.bodythemedark .arrowback svg {\n  fill: $white-color;\n}\n\n.bodythemedark .drpdwn_btn {\n  background-color: $darkTheme_blue;\n}\n\n.bodythemedark .empname {\n  color: $lightthemetext !important;\n}\n\n.bodythemedark .navitemli a {\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n.bodythemedark .tabnavli a.settingsgeneral, \n.bodythemedark .tabnavli a.settingslinks:hover {\n  background-color: $darkTheme_updateBtn;\n  color: $white-color;\n}\n.bodythemedark .tabnavli a.settingslinks {\n  background-color: transparent;\n  border: solid 1px $darkTheme_updateBtn;\n  color: $white-color;\n}\n\n\n@media only screen and (max-width: 1200px) {\n  .tableheadlight th {\n    min-width: 100px;\n  }\n}\n@media only screen and (max-width: 1024px) { \n  .dashboard {\n    width: calc(100% - 50px) !important;\n    left: 50px !important;\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 998px) { \n  #dashboardcont2{\n    height: auto !important;\n  }\n}\n@media only screen and (max-width: 767px) { \n  .sectionright{\n    float: unset !important;\n  }\n  .dashboard {\n    padding: 10px 10px !important;\n  }\n}\n@media only screen and (max-width: 600px) {\n  .cont2 {\n    width: $dashwidth !important;\n    left: $dashleft !important;\n    position: relative !important;\n    padding: 20px 10px !important;\n  }\n  .bodythemelight, .bodythemedark {\n    padding-top: 165px;\n  }\n}\n\n@media (min-width: 576px) {\n  .exer_modal_contain .modal-dialog {\n      max-width: 1055px;\n  }\n  .delPopContainer .modal-dialog {\n      max-width: 350px;\n  }\n}","@import \"../../styles/Variables/Variables.scss\";\n\n/* Popup style */\n.popupbox {\n    position: fixed;\n    background: rgb(0 0 0 / 46%);\n    width: 100%;\n    height: 100vh;\n    top: 0;\n    left: 0;\n    z-index: 99 ;\n  }\n   \n  #box {\n    position: relative;\n    width: 55%;\n    margin: 0 auto;\n    height: auto;\n    max-height: 70vh;\n    margin-top: calc(100vh - 70vh - 20px);\n    border-radius: 4px;\n    padding: 20px;\n    overflow: auto;\n  }\n   \n  .closeicon {\n    content: 'x';\n    cursor: pointer;\n    position: fixed;\n    right: calc(22% - 18px);\n    top: calc(100vh - 73vh - 25px);\n    background: #ededed;\n    width: 25px;\n    height: 25px;\n    border-radius: 50%;\n    line-height: 20px;\n    text-align: center;\n    border: 1px solid #999;\n    font-size: 20px;\n  }\n  \n\n  #addheading{\n    font-size: 20px;\n}\n\n.nametitle{\n    font-size: 16px;\n     \n}\n.name{\n    font-size: 16px;\n    color: $white-color;\n     \n}\n.detailsdiv{\n    padding: 5px;\n    background-color: $white-color;\n}\n\n.profilepicdiv{\n    // padding: 10px;\n    border-radius: 5px;\n}\n\n.profile_imgsection{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.profilepic{\n    width: 100px;\n    height: 100px;\n    border-radius: 50%;\n    border: 1px solid #21252975;\n    padding: 5px;\n}\n\n.namesection{\n    text-align: center;\n}\n\n#profilename{\n    font-size: 14px;\n    margin-top: 30px;\n    text-align: center;\n}\n.profileemail{\n    font-size: 12px;\n     \n}\n#profiledob{\n    font-size: 12px;\n     \n}\n\n#empdiv{\n    padding:5px 0px 0px 15px;\n    margin-bottom: 10px;\n    border-radius: 5px;\n\n    .title{\n         \n        font-size: 13px;\n    }\n\n    .empname{\n        font-size: 14px;\n        padding-bottom:8px;\n        word-break: break-word;\n    }\n}\n\n\n\n@media only screen and (max-width: 400px) {\n    #box {\n        width: 80%;\n        margin: 90px 40px;\n      }\n\n      .closeicon {\n        right: calc(32% - 64px);\n        top: calc(23vh - 25px);\n      }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dashboard": `TableViewPopup_dashboard__Bk8Cv`,
	"dashboardContain": `TableViewPopup_dashboardContain__tpS2Y`,
	"bodythemedark": `TableViewPopup_bodythemedark__eT38U`,
	"cont2": `TableViewPopup_cont2__WSly8`,
	"top_header": `TableViewPopup_top_header__PG0wA`,
	"top_header_inner": `TableViewPopup_top_header_inner__z02ox`,
	"subLink": `TableViewPopup_subLink__pQ1zR`,
	"footer": `TableViewPopup_footer__6yLKS`,
	"bodythemelight": `TableViewPopup_bodythemelight__fp7qv`,
	"headerthemelight": `TableViewPopup_headerthemelight__Jza1g`,
	"headerthemedark": `TableViewPopup_headerthemedark__LXffa`,
	"menuthemelight": `TableViewPopup_menuthemelight__LhB3c`,
	"menuthemedark": `TableViewPopup_menuthemedark__kDS-2`,
	"menulinklight": `TableViewPopup_menulinklight__X6MCA`,
	"menulinkdarkSelected": `TableViewPopup_menulinkdarkSelected__O+6+L`,
	"menulinklightSelected": `TableViewPopup_menulinklightSelected__QmHyj`,
	"menulinkdark": `TableViewPopup_menulinkdark__0CoHZ`,
	"headinglight": `TableViewPopup_headinglight__X-ybd`,
	"headingdark": `TableViewPopup_headingdark__K-CKc`,
	"searchboxlight": `TableViewPopup_searchboxlight__IW4y0`,
	"searchboxdark": `TableViewPopup_searchboxdark__yI0sj`,
	"tableheadlight": `TableViewPopup_tableheadlight__fLoF6`,
	"tableheaddark": `TableViewPopup_tableheaddark__ByeKf`,
	"table": `TableViewPopup_table__p20dt`,
	"table-borderless": `TableViewPopup_table-borderless__6wz24`,
	"left-section": `TableViewPopup_left-section__YKZOb`,
	"tablebodylight": `TableViewPopup_tablebodylight__eYYYF`,
	"tablebodydark": `TableViewPopup_tablebodydark__jZy-n`,
	"paginationlight": `TableViewPopup_paginationlight__x+QwH`,
	"paginationdark": `TableViewPopup_paginationdark__jrN5e`,
	"formthemelight": `TableViewPopup_formthemelight__9E6G5`,
	"formthemedark": `TableViewPopup_formthemedark__SEbrt`,
	"viewformlight": `TableViewPopup_viewformlight__pK93I`,
	"permissionboxlight": `TableViewPopup_permissionboxlight__omoDD`,
	"permissionboxdark": `TableViewPopup_permissionboxdark__dI-1S`,
	"errormsgclr": `TableViewPopup_errormsgclr__40cyw`,
	"graphclrlight": `TableViewPopup_graphclrlight__SG+F5`,
	"graphclrdark": `TableViewPopup_graphclrdark__TCTv8`,
	"card1bglight": `TableViewPopup_card1bglight__xbpCL`,
	"card1bgdark": `TableViewPopup_card1bgdark__Q9o0M`,
	"card2bglight": `TableViewPopup_card2bglight__qvHLE`,
	"card2bgdark": `TableViewPopup_card2bgdark__fuIJ1`,
	"card3bglight": `TableViewPopup_card3bglight__ybE2T`,
	"card3bgdark": `TableViewPopup_card3bgdark__UNBgK`,
	"card4bglight": `TableViewPopup_card4bglight__TKUGy`,
	"card4bgdark": `TableViewPopup_card4bgdark__1QTv4`,
	"actionbtnlight": `TableViewPopup_actionbtnlight__gwhXA`,
	"actionbtndark": `TableViewPopup_actionbtndark__a9GeW`,
	"profiledropdownlight": `TableViewPopup_profiledropdownlight__Ky5fH`,
	"profiledropdowndark": `TableViewPopup_profiledropdowndark__0TwsG`,
	"settingsection": `TableViewPopup_settingsection__1qZmP`,
	"addform": `TableViewPopup_addform__-eoSQ`,
	"savebtn": `TableViewPopup_savebtn__V2WZc`,
	"profile_conatiner": `TableViewPopup_profile_conatiner__0Hgao`,
	"ag-theme-alpine": `TableViewPopup_ag-theme-alpine__pH-D3`,
	"ag-row": `TableViewPopup_ag-row__2cNcJ`,
	"formbtn": `TableViewPopup_formbtn__CH0BD`,
	"resetbtn": `TableViewPopup_resetbtn__N+kZd`,
	"addBtn": `TableViewPopup_addBtn__IqAbp`,
	"cust_addBtn": `TableViewPopup_cust_addBtn__sKmpU`,
	"deleteBtn": `TableViewPopup_deleteBtn__+PFBA`,
	"confirmBtn": `TableViewPopup_confirmBtn__TeC2Y`,
	"back_dlt": `TableViewPopup_back_dlt__p5TeG`,
	"delPopContainer": `TableViewPopup_delPopContainer__JGVWI`,
	"modal-body": `TableViewPopup_modal-body__cHyaE`,
	"delet_icon": `TableViewPopup_delet_icon__922fy`,
	"arrowback": `TableViewPopup_arrowback__zhNwv`,
	"drpdwn_btn": `TableViewPopup_drpdwn_btn__tA3kq`,
	"empname": `TableViewPopup_empname__cUDDH`,
	"navitemli": `TableViewPopup_navitemli__GyHqs`,
	"tabnavli": `TableViewPopup_tabnavli__-xb-e`,
	"settingsgeneral": `TableViewPopup_settingsgeneral__hwXei`,
	"settingslinks": `TableViewPopup_settingslinks__TqsRQ`,
	"dashboardcont2": `TableViewPopup_dashboardcont2__hWMNB`,
	"sectionright": `TableViewPopup_sectionright__mOBUK`,
	"exer_modal_contain": `TableViewPopup_exer_modal_contain__nwIVN`,
	"modal-dialog": `TableViewPopup_modal-dialog__Lc0ex`,
	"popupbox": `TableViewPopup_popupbox__a0ady`,
	"box": `TableViewPopup_box__2aK4E`,
	"closeicon": `TableViewPopup_closeicon__xX-PQ`,
	"addheading": `TableViewPopup_addheading__L0Wjm`,
	"nametitle": `TableViewPopup_nametitle__1BORB`,
	"name": `TableViewPopup_name__d-fY-`,
	"detailsdiv": `TableViewPopup_detailsdiv__v6KtY`,
	"profilepicdiv": `TableViewPopup_profilepicdiv__JsY9Q`,
	"profile_imgsection": `TableViewPopup_profile_imgsection__Tz7nf`,
	"profilepic": `TableViewPopup_profilepic__igUKH`,
	"namesection": `TableViewPopup_namesection__jDhA7`,
	"profilename": `TableViewPopup_profilename__xS1eF`,
	"profileemail": `TableViewPopup_profileemail__sIv64`,
	"profiledob": `TableViewPopup_profiledob__CoUKF`,
	"empdiv": `TableViewPopup_empdiv__2+KYM`,
	"title": `TableViewPopup_title__QI5k1`
};
export default ___CSS_LOADER_EXPORT___;
